export const blockIconsDeviceTask = (
	<span className='material-symbols-outlined'>task</span>
);
